import React from "react";
import "./LogoutPopupStyle.css";
import Button from "../../Button/Button";

const LogoutPopup = ({
  showActive,
  message,
  onCancel,
  onAllow,
  userId,
  isPopupFetching,
  variant = "danger", // 'danger' | 'info' | 'success'
  confirmLabel = "Yes, I'm Sure",
  cancelLabel = "No, Cancel",
}) => {
  const handleCancel = () => {
    if (typeof onCancel === "function") onCancel(false);
  };

  const handleAllow = () => {
    if (typeof onAllow !== "function") return;
    if (userId) {
      onAllow(userId);
    } else {
      onAllow(true);
    }
  };

  return (
    <div
      className={`popupWrapper logoutPop ${showActive ? "active" : ""}`}
      onClick={(e) => {
        if (e.target === e.currentTarget) handleCancel();
      }}
    >
      <div className="popupContainer LogoutPopup">
        <div className="popupHeader">
          <button
            type="button"
            className="close"
            onClick={handleCancel}
            aria-label="Close"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M6 6l12 12M18 6l-12 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>

        <div className="popupBody flexbox">
          <div className={`popBodyWrap flexbox popBodyIcon ${variant}`}>
            {variant === "success" ? (
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            ) : variant === "info" ? (
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
                <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            ) : (
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
                <path d="M12 9v4M12 17h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            )}
          </div>

          <p className="logOutText flexbox">{message}</p>

          <div className="buttonWrapper">
            <Button
              className={variant === "danger" ? "RedFillButton" : "BlueFillButton"}
              name={confirmLabel}
              isWaiting={isPopupFetching}
              disabled={isPopupFetching}
              onClick={handleAllow}
            />
            <Button
              className={"GreyBorderButton"}
              name={cancelLabel}
              onClick={handleCancel}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutPopup;
